import { AddonsResponse, JourneyMapType } from '@/src/types/itinerary'
import {
    getBaggageAncillaries,
    getMealAncillaries,
    getSeatAncillaries,
    processSelectedAncillaries
} from './addonsProcessor'
import { getJourneyMap } from './addonsProcessor/common'

/**
 * Main function to transform addons data
 */
const transformAddonsData = (addonsData: AddonsResponse) => {
    const { data } = addonsData || {}
    const { tripAncillaryResponseList } = data || {}
    const ancillaryDetails = tripAncillaryResponseList?.[0]?.ancillaryDetails
    const { journeyAncillaries = [], userSelectedAncillaries } = ancillaryDetails || {}

    // Process all ancillary types
    const { baggageAncillaries, isBaggageAvailable } = getBaggageAncillaries(journeyAncillaries)
    const { mealAncillaries, isMealAvailable } = getMealAncillaries(journeyAncillaries)
    const { seatAncillaries, isSeatAvailable } = getSeatAncillaries(journeyAncillaries)

    // Process journey map to map segments to journey for update ancillary payload
    const journeyMap: JourneyMapType = getJourneyMap(journeyAncillaries)

    // Process selected ancillaries with access to processed ancillary data
    const selectedAncillaries = processSelectedAncillaries(
        userSelectedAncillaries,
        baggageAncillaries,
        mealAncillaries,
        seatAncillaries
    )

    return {
        journeyAncillaries: {
            baggageAncillaries,
            mealAncillaries,
            seatAncillaries
        },
        ancillaryStatus: {
            isBaggageAvailable,
            isMealAvailable,
            isSeatAvailable
        },
        journeyMap,
        selectedAncillaries
    }
}

export default transformAddonsData
